/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from "react";

export class WrcVAS extends React.Component {
    constructor(props) {
        super(props);

        let startX = 0;
        let startY = 0;
        let endX = 0;
        let endY = 0;
        if (this.props.data[this.props.element.id + '_value'] !== undefined) {
            startX = this.props.data[this.props.element.id + '_start_x'];
            startY = this.props.data[this.props.element.id + '_start_y'];
            endX = this.props.data[this.props.element.id + '_end_x'];
            endY = this.props.data[this.props.element.id + '_end_y'];
        }
        this.state = {
            is_loaded: false,
            startX: startX,
            startY: startY,
            endX: endX,
            endY: endY,
            isDrawing: false
        };
    }

    componentDidMount() {
        this.setState({
            is_loaded: true
        });

        let canvas = document.getElementById(this.props.element.id);
        let ctx = canvas.getContext("2d");

        if (this.props.data[this.props.element.id + '_value'] !== undefined) {
            ctx.strokeStyle = "black";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(this.state.startX, this.state.startY);
            ctx.lineTo(this.state.endX, this.state.endY);
            ctx.stroke();
        }
    }

    render() {
            return (
                <canvas
                        id={this.props.element.id}
                        height={this.props.element.height}
                        width={this.props.element.width}
                        style={{background: "url('" + this.props.element.image_source + "')"}}
                        onMouseDown={this.onMouseDown}
                        onMouseUp={this.onMouseUp}
                        onMouseMove={this.onMouseMove}>
                </canvas>
            );
    }

    onMouseDown = (e) => {
        if (this.state.is_loaded && e.button === 0) {
            let canvas = document.getElementById(this.props.element.id);
            let bounds = canvas.getBoundingClientRect();
            let ctx = canvas.getContext("2d");

            let startX = e.clientX - bounds.left;
            let startY = e.clientY - bounds.top;
            if (startX >= this.props.element.box.left && startX <= this.props.element.box.right
                    && startY >= this.props.element.box.top && startY <= this.props.element.box.bottom) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                this.setState({
                    startX: startX,
                    startY: startY,
                    isDrawing: true
                });
            }
        }
    }
    onMouseUp = (e) => {
        if (this.state.is_loaded && e.button === 0) {
            if (this.state.isDrawing) {
                let canvas = document.getElementById(this.props.element.id);
                let ctx = canvas.getContext("2d");

                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (this.state.endX >= this.props.element.scale.left) {
                    ctx.strokeStyle = "black";
                    ctx.lineWidth = 2;
                    ctx.beginPath();
                    ctx.moveTo(this.state.startX, this.state.startY);
                    ctx.lineTo(this.state.endX, this.state.endY);
                    ctx.stroke();
                    this.props.recordData({
                        [this.props.element.id + '_start_x']: this.state.startX,
                        [this.props.element.id + '_start_y']: this.state.startY,
                        [this.props.element.id + '_end_x']: this.state.endX,
                        [this.props.element.id + '_end_y']: this.state.endY,
                        [this.props.element.id + '_value']: Math.round(100 - (this.state.endY - this.props.element.scale.top) / (this.props.element.scale.bottom - this.props.element.scale.top) * this.props.element.scale.points)
                    });
                }

                this.setState({isDrawing: false});
            }
        }
    }
    onMouseMove = (e) => {
        if (this.state.isDrawing) {
            let canvas = document.getElementById(this.props.element.id);
            let bounds = canvas.getBoundingClientRect();
            let ctx = canvas.getContext("2d");

            let endX = e.clientX - bounds.left;
            let endY = e.clientY - bounds.top;
            if (endX > this.props.element.scale.right) {
                endX = this.props.element.scale.right;
            }
            if (endX < this.state.startX) {
                endX = this.state.startX;
            }
            if (endY < this.props.element.scale.top) {
                endY = this.props.element.scale.top;
            } else if (endY > this.props.element.scale.bottom) {
                endY = this.props.element.scale.bottom;
            }
            this.setState({
                endX: endX,
                endY: endY
            })

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.strokeStyle = "darkred";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(this.state.startX, this.state.startY);
            ctx.lineTo(this.state.endX, this.state.endY);
            ctx.stroke();
        }
    }
}

export default WrcVAS;